import {
  Box,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Portal,
  Stack,
  Wrap,
  WrapItem,
  StackProps,
} from "@chakra-ui/react";
import { Text14 } from "components/Text";

interface PopoverTagColumnOptions<TItem> {
  items: TItem[];
  renderTag: (item: TItem) => React.ReactNode;
  displaySummary?: (items: TItem[], summary: string) => React.ReactNode;
  generateSummary?(items: TItem[]): string;
  keyFn?: (item: TItem) => string;
  emptyLabel?: string;
  popoverContainerContentProps?: StackProps;
}

export default function PopoverTagColumn<TItem>({
  items = [],
  renderTag,
  displaySummary = (_, summary) => (<Text14>{summary}</Text14>),
  generateSummary = (innerItems: TItem[]) => `${innerItems.length} Items`,
  keyFn = (item: any) => item.id,
  emptyLabel = "None",
  popoverContainerContentProps = {},
}: PopoverTagColumnOptions<TItem>) {
  if (!items || items.length === 0) {
    return <Text14 bg="bg.muted" py="1" px="2" borderRadius="md">{emptyLabel}</Text14>;
  }

  return (
    <Popover trigger="hover" isLazy>
      <PopoverTrigger>
        <Box>
          {displaySummary(items, generateSummary(items))}
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody>
            <Stack gap="1" {...popoverContainerContentProps}>
              <Wrap>
                {items.map((item) => (
                  <WrapItem key={keyFn(item)}>{renderTag(item)}</WrapItem>
                ))}
              </Wrap>
            </Stack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
